import { render } from "./EditBadges.vue?vue&type=template&id=19a2710d&scoped=true"
const script = {}

import "./EditBadges.vue?vue&type=style&index=0&id=19a2710d&scoped=true&lang=css"

import exportComponent from "/home/circleci/app-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19a2710d"]])

export default __exports__